import { isUserLoggedIn } from "../helpers";

export default class ApiHelper {
    constructor() {
        this.initApiAnonToken("wishlist_anon_token");
        this.apiSecret = this.getApiToken();
        this.initApiUrl();
    }
    initApiUrl() {
        this.apiUrl = "https://api.lucchese.com/api";
        if (window.location.host === "lucchese-staging.myshopify.com") {
            this.apiUrl = "https://stg-api.lucchese.com/api";
        }
    }

    generateUniqueToken() {
        return btoa(Date.now().toString(36) + Math.random().toString(36).substring(2));
    }

    getApiToken() {
        let wishlistToken = this.getUserLoggedApiToken();
        if (!wishlistToken) {
            wishlistToken = this.getApiAnonToken("wishlist_anon_token");
        }

        return wishlistToken;
    }

    getUserLoggedApiToken() {
        let wishlistToken = "";
        if (isUserLoggedIn()) {
            wishlistToken = Shopify.theme_settings.api_secret;
        }

        return wishlistToken;
    }

    initApiAnonToken(cookieForAnonymousAccountName) {
        let wishlistToken = this.getApiAnonToken(cookieForAnonymousAccountName);
        if (!wishlistToken) {
            this.createApiAnonToken(cookieForAnonymousAccountName);
        }
    }

    getApiAnonToken(cookieForAnonymousAccountName) {
        let wishlistToken = "";
        const match = document.cookie.match(RegExp("(?:^|;\\s*)" + cookieForAnonymousAccountName + "=([^;]*)"));
        if (match) {
            wishlistToken = match[1];
        }

        return wishlistToken;
    }

    createApiAnonToken(cookieForAnonymousAccountName) {
        const cookieForAnonymousAccountValue = this.generateUniqueToken();
        const days = 90;
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = "; expires=" + date.toUTCString();
        document.cookie = `${cookieForAnonymousAccountName}=${cookieForAnonymousAccountValue || ""}${expires}; path=/`;
        return cookieForAnonymousAccountValue;
    }

    getHeaders(xApiToken) {
        xApiToken = xApiToken || this.apiSecret;

        return {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-api-token": xApiToken,
        };
    }
}
